function styleRechargeWidget() {
  const widgets = document.querySelectorAll('recharge-subscription-widget');

  widgets.forEach((el) => {
    if (!el.shadowRoot) return;
    if (!el.shadowRoot.querySelector('.rc-purchase-option')) return;

    if (!el.shadowRoot.querySelector('[data-theme-recharge-styles]')) {
      const style = document.createElement('style');
      style.setAttribute('data-theme-recharge-styles', '');

      style.textContent = `
        .rc-selection__root {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-4);
          color: #8B4346;
        }

        .rc-selection__root .rc-purchase-option {
          border: none;
          border-radius: var(--rounded-button);
          background: rgb(var(--background-primary));
          transition: border-color 0.2s ease;
          overflow: visible;
        }

        .rc-selection__root .rc-purchase-option[rc-selected] {
          outline: 2px solid #8B4346;
          outline-offset: -2px;
          background: #ffffff;
          color: #8B4346;
        }

        .rc-selection__root .rc-purchase-option:not(:last-child) {
            margin-bottom: 0;
        }

        .rc-selection__root .rc-purchase-option__label {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          gap: var(--spacing-2);
          padding: var(--spacing-3-5) var(--spacing-5-5);
          cursor: pointer;
        }

        .rc-selection__root .rc-purchase-option__selector {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          font-size: var(--text-base);
        }

        .rc-selection__root .rc-purchase-option__prices {
          display: flex;
          gap: var(--spacing-1-5);
          text-align: right;
          font-size: var(--text-base);
        }

        .rc-selection__root .rc-price.text-muted {
          display: inline-block;
          color: #8B4346;
          opacity: 0.7;
        }

        .rc-selection__root .rc-purchase-option__badge {
          margin: var(--spacing-1) var(--spacing-2) 0;
          font-size: var(--text-sm);
          background: #FBFB87;
          color: #8B4346;
          padding: var(--spacing-2) var(--spacing-3);
          border-radius: var(--rounded);
        }

        .rc-selection__root .rc-purchase-option__input {
          appearance: none;
          width: 19px;
          height: 19px;
          flex-shrink: 0;
          border-radius: 50%;
          outline: 2px solid #8B4346;
          outline-offset: -1px;
          position: relative;
          cursor: pointer;
        }

        .rc-selection__root .rc-purchase-option__input:checked::after {
          content: '';
          position: absolute;
          inset: 3px;
          border-radius: 50%;
          background: #8B4346;
        }

        .rc-selection__root rc-radio-icon {
          display: none;
        }

        .rc-selection__root .rc-purchase-option__sub-container {
          padding: var(--spacing-3-5);
          margin-top: calc(var(--spacing-4-5) * -1);
        }

        .rc-selection__root rc-benefits{
          padding: 0 var(--spacing-2) var(--spacing-1-5) var(--spacing-2);
          font-size: var(--text-sm);
          line-height: 1.6;
        }

        .rc-selection__root rc-learn-more {
          display: none;
        }
      `;

      el.shadowRoot.appendChild(style);
    }

    styleRechargeSellingPlans(el);

    el.style.display = 'block';

    if (!el.__themeRechargeObserver) {
      let shadowTimeout;

      el.__themeRechargeObserver = new MutationObserver(() => {
        clearTimeout(shadowTimeout);
        shadowTimeout = setTimeout(() => {
          styleRechargeSellingPlans(el);
        }, 20);
      });

      el.__themeRechargeObserver.observe(el.shadowRoot, {
        childList: true,
        subtree: true
      });
    }
  });
}

function styleRechargeSellingPlans(widgetEl) {
  const plans = widgetEl.shadowRoot.querySelectorAll('rc-selling-plans');

  plans.forEach((planEl) => {
    if (!planEl.shadowRoot) return;
    if (planEl.shadowRoot.querySelector('[data-theme-selling-plan-styles]')) return;

    const planStyle = document.createElement('style');
    planStyle.setAttribute('data-theme-selling-plan-styles', '');

    planStyle.textContent = `
      .rc-plans-dropdown {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
        font-size: var(--text-sm);
      }

      .rc-plans__label {
        display: none;
        font-size: var(--text-sm);
        color: #8B4346;
      }

      .rc-plans-dropdown__select {
        appearance: none;
        width: 100%;
        height: var(--input-height);
        padding: 0 var(--spacing-4);
        padding-right: calc(var(--spacing-4) + 24px);
        border-radius: var(--rounded-input);
        border: 1px solid rgb(var(--text-primary) / 0.12);
        background: rgb(var(--background-primary));
        font-family: var(--text-font-family);
        font-size: var(--text-base);
        color: #8B4346;
      }

      .rc-plans-dropdown__select:focus {
        outline: none;
        border-color: #8B4346;
        box-shadow: inset 0 0 0 1px #8B4346;
      }

      .rc-plans-dropdown__icon {
        position: absolute;
        right: var(--spacing-3);
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        color: #8B4346;
      }
        flex-shrink: 0;
    `;

    planEl.shadowRoot.appendChild(planStyle);
  });
}

styleRechargeWidget();
requestAnimationFrame(styleRechargeWidget);

setTimeout(styleRechargeWidget, 20);
setTimeout(styleRechargeWidget, 40);
setTimeout(styleRechargeWidget, 80);
setTimeout(styleRechargeWidget, 160);
setTimeout(styleRechargeWidget, 320);
setTimeout(styleRechargeWidget, 640);
setTimeout(styleRechargeWidget, 1280);
setTimeout(styleRechargeWidget, 2560);
setTimeout(styleRechargeWidget, 5120);

document.addEventListener('shopify:section:load', styleRechargeWidget);

let rechargeTimeout;

new MutationObserver(() => {
  clearTimeout(rechargeTimeout);
  rechargeTimeout = setTimeout(styleRechargeWidget, 60);
}).observe(document.documentElement, {
  childList: true,
  subtree: true
});